export const diffDays = (left: Date, right: Date) =>
  Math.round(Math.abs((+left - +right) / (24 * 60 * 60 * 1000)));
export const diffDaysNow = (left: Date) => diffDays(left, new Date());
